module.exports = __webpack_public_path__ + "static/WPAI-logo.fbd87532.png";